import { useOrganization } from 'hooks/store';

export default function useEquipmentEnabled() {
  const { trackEquipment } = useOrganization();
  return !!trackEquipment;
}
